import Siema from 'siema';

Array.from(document.querySelectorAll('.js-carousel')).forEach(carousel => {
  const wrapper = carousel.querySelector('.js-carousel-wrapper');
  const prev = carousel.querySelector('.js-carousel-prev');
  const next = carousel.querySelector('.js-carousel-next');

  if (wrapper) {
    const siema = new Siema({
      selector: wrapper,
      speed: 350,
      loop: true,
      perPage: {
        500: 2,
        750: 3,
      },
    });

    prev.addEventListener('click', () => siema.prev());
    next.addEventListener('click', () => siema.next());
  }
});
